module.exports = __webpack_public_path__ + "static/jergal_larian_afbg3-d6252e101ce08bba162922554711695a.webp";